import { ReactElement, useState } from 'react';
import { CircularProgress, Typography } from '@mui/material';

import { useGetRawSettingsQuery } from '../../services/rtk/SettingsAPI';
import EditSettingDialog from './components/EditSettingDialog';
import SettingsTable, { SettingsRowData } from './components/SettingsTable';

function AdminSettings(): ReactElement {
    const { data, isLoading, isError } = useGetRawSettingsQuery();
    const [editKey, setEditKey] = useState<string | null>(null);

    if (isLoading) return <CircularProgress />;
    if (isError || !data) return <Typography color="error">Failed to load settings.</Typography>;

    const rows: SettingsRowData[] = Object.entries(data).map(([key, setting]) => ({
        key,
        setting
    }));

    const editSetting = editKey ? data[editKey] : null;

    return (
        <>
            <Typography variant="h5" gutterBottom>
                Admin Settings
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                All settings with their default values and override rules.
            </Typography>
            <SettingsTable rows={rows} onEdit={setEditKey} />
            {editKey && editSetting && (
                <EditSettingDialog
                    settingKey={editKey}
                    setting={editSetting}
                    open={true}
                    onClose={() => setEditKey(null)}
                />
            )}
        </>
    );
}

export default AdminSettings;
